import React, { useState } from 'react';
import { Auth } from 'aws-amplify';
import { SignForm } from '../../models/signForm';
import { Form, Input, Button, Row, message } from 'antd';
import { AuthState } from '@aws-amplify/ui-components';
import { useHistory } from 'react-router-dom';
import Title from 'antd/lib/typography/Title';
import { ValidateErrorEntity } from 'rc-field-form/lib/interface';
import { InternalNamePath } from 'antd/lib/form/interface';
import { Redirect } from 'react-router-dom';
import Link from 'antd/lib/typography/Link';
import Paragraph from 'antd/lib/typography';
import Text from 'antd/lib/typography';

interface FormValues {
  Email: string;
  password: string;
  verificationCode: string;
}

const SignIn: React.FC<SignForm> = ({ authState, setAuthState }) => {
  const [submitting, setSubmitting] = useState(false);
  const [confirmUserState, setConfirmUserState] = useState(false);
  const history = useHistory();

  const signingInUser = (Email: string, password: string) => {
    Auth.signIn(Email, password)
      .then(() => {
        setSubmitting(false);
        setAuthState(AuthState.SignedIn);
      })
      .catch((error) => {
        if (error.code === 'UserNotConfirmedException') {
          setConfirmUserState(true);
        } else {
          message.error('Invalid username or password.');
        }
        setSubmitting(false);
        setAuthState(AuthState.SignOut);
      });
  };
  const confirmUser = (
    Email: string,
    password: string,
    verificationCode: string
  ) => {
    Auth.confirmSignUp(Email, verificationCode)
      .then(async () => {
        signingInUser(Email, password);
      })
      .catch((e) => {
        setSubmitting(false);
        message.error(e['message'], 8);
      });
  };
  const onFinish = async (values: FormValues): Promise<void> => {
    setSubmitting(true);
    if (confirmUserState) {
      confirmUser(values.Email, values.password, values.verificationCode);
    } else {
      signingInUser(values.Email, values.password);
    }
  };

  const onFinishFailed = (errorInfo: ValidateErrorEntity<FormValues>): void => {
    errorInfo.errorFields.map(
      (item: { name: InternalNamePath; errors: string[] }) => {
        return message.error(item.errors[0]);
      }
    );

    console.log('Failed:', errorInfo);
  };

  if (authState && authState === AuthState.SignedIn) {
    return <Redirect to="/" />;
  }

  return (
    <>
      <Row justify="center">
        {confirmUserState ? (
          <Title level={3}>Verify your account</Title>
        ) : (
          <Title level={3}>Sign in</Title>
        )}
      </Row>
      {confirmUserState && (
        <Paragraph style={{ marginBottom: '20px' }}>
          Please check your emails for the verification code and copy it here:
        </Paragraph>
      )}
      <Form
        layout="vertical"
        name="basic"
        initialValues={{
          remember: true
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Form.Item
          label="Email"
          data-cy="signInEmail"
          hidden={confirmUserState}
          name="Email"
          rules={[
            {
              required: true,
              message: 'Please input your username!'
            }
          ]}
        >
          <Input size="large" style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item
          label="Password"
          hidden={confirmUserState}
          data-cy="signInPassword"
          name="password"
          rules={[
            {
              required: true,
              message: 'Please input your password!'
            }
          ]}
        >
          <Input.Password size="large" style={{ width: '100%' }} />
        </Form.Item>
        {confirmUserState ? (
          <>
            <Form.Item
              label="Verification Code"
              name="verificationCode"
              rules={[
                {
                  required: true,
                  message: 'Please input the verification code!'
                }
              ]}
            >
              <Input size="large" style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                size="large"
                block
                loading={submitting}
              >
                Submit
              </Button>
            </Form.Item>
          </>
        ) : (
          <Form.Item>
            <Button
              type="primary"
              data-cy="signIn"
              htmlType="submit"
              size="large"
              block
              loading={submitting}
            >
              Sign In
            </Button>
          </Form.Item>
        )}
      </Form>
      <Row data-cy="signUp" justify="center">
        <Text>
          Don't have an account yet?{' '}
          <Link onClick={(): void => history.push('/signup')}>
            Sign up for free
          </Link>
        </Text>
      </Row>
      <Row justify="center">
        <Text>
          Having issues signing in?{' '}
          <Link onClick={(): void => history.push('/resetpassword')}>
            Reset password
          </Link>
        </Text>
      </Row>
    </>
  );
};

export default SignIn;
